type DebugRect = {
  width: number;
  height: number;
};

function roundDebugMetric(value: number) {
  return Math.round(value * 100) / 100;
}

export function toProductCardDebugRect(rect: DOMRect | null | undefined): DebugRect | null {
  if (!rect) return null;
  return {
    width: roundDebugMetric(rect.width),
    height: roundDebugMetric(rect.height),
  };
}
